import * as ActionTypes from "services/state/action-types"

const PERMISSIONS_INITIAL_STATE = {
  loading: true,
  error: false,
  data: { mainMenu: [], pages: [] }
}

export function permissions(state = PERMISSIONS_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_PERMISSIONS:
      return { ...state, loading: true, error: false }

    case ActionTypes.GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data
      }

    case ActionTypes.GET_PERMISSIONS_FAIL:
      return { ...state, loading: false, error: true }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/state/permissions/reducer.js